'use strict';
/* eslint no-sync: 0 */

export class NavbarComponent {
  menu = [{
    title: 'Home',
    state: 'login',
    icon: 'fa-home'
  }, {
    title: 'Map',
    state: 'home',
    icon: 'fa-globe'
  }];

  isCollapsed = true;

  constructor(Auth, $scope, $state, $timeout, $localStorage, Util, appConfig) {
    'ngInject';
    let $ctrl = this;
    this.Util = Util;
    this.appConfig = appConfig;
    this.$state = $state;
    this.$localStorage = $localStorage;
    this.calibrated = $localStorage.calibrated || false;
    this.isLoggedIn = Auth.isLoggedInSync;
    this.isAdmin = Auth.isAdminSync;
    this.getCurrentUser = Auth.getCurrentUserSync;
    this.sectors = [];
    this.screenChanged = false;

    this.sectorsEnabled = appConfig.siteSectorsEnabled;

    $scope.$on('$stateChangeStart', (event, toState) => {
      // hide navbar if state is login state
      this.hideNavbar = toState.hideNavbar === true ? true : false;
    });


    $scope.$on('ts:screenCalibrated', () => {
      $ctrl.calibrated = true;
      $ctrl.screenChanged = false;
      $timeout(() => {
        $scope.$apply();
      });
    });
    $scope.$on('ts:screenChanged', () => {
      // We are using a different screen, alert the user their
      // screen may be no longer calibrated.
      $ctrl.screenChanged = true;
      $localStorage.calibrated = false;
      $ctrl.calibrated = false;
      $timeout(() => {
        $scope.$apply();
      });
    });
    $scope.$on('ts:screenRestored', () => {
      // We are using a different screen, alert the user their
      // screen may be no longer calibrated.
      $ctrl.screenChanged = false;
      $localStorage.calibrated = true;
      $ctrl.calibrated = true;
      $timeout(() => {
        $scope.$apply();
      });
    });

    _.each($ctrl.appConfig.siteSectors, sectorName => {
      $ctrl.sectors.push({
        name: sectorName,
        active: true,
        icon: sectorName
      });
    });

    $ctrl.selectedSectors = [$ctrl.sectors[0]];

    $scope.$on('mapboxglMap:render', () => {
      $ctrl.toggleSector();
    });
  }

  back() {
    this.Util.goBack();
  }

  toggleSector(sector) {
    if(sector) {
      if(this.selectedSectors.indexOf(sector) > -1) {
        this.selectedSectors.splice(this.selectedSectors.indexOf(sector), 1);
      } else {
        this.selectedSectors.push(sector);
      }
    }

    $('.marker').removeClass('active');
    _.each(this.selectedSectors, sector => {
      $('.icon-' + sector.name).addClass('active');
    });
  }

  canGoBack() {
    return this.$state.current.name !== 'home';
  }
}

export default angular.module('directives.navbar', [])
  .component('navbar', {
    template: require('./navbar.html'),
    controller: NavbarComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js